// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"536":"073b7821","606":"dca41faf","728":"0bf12701"}[chunkId] + ".chunk.js";
};